<template>
  <el-pagination
    background
    style="text-align: center;"
    :current-page.sync="config.pageNum"
    :page-size="config.pageSize"
    :page-sizes="pageSizes"
    layout="total, prev, pager, next, sizes"
    :total="total"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange">
  </el-pagination>
</template>

<script>
import { mapState } from 'vuex'
function noop() {}
export default {
  name: 'PaginationNew',
  props: {
    total: {
      type: Number,
      default: 0
    },
    value: {
      type: Object,
      default() {
        return {
          pageNum: 1,
          pageSize: 10
        }
      }
    },
    fetch: {
      type: Function,
      default: noop
    }
  },
  computed: {
    ...mapState({
      pageSizes: state => state.account.pageSizes
    }),
    config: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleSizeChange(val) {
      this.config.pageSize = val
      this.config.pageNum = 1
      this.$nextTick(() => {
        this.fetch()
      })
    },
    handleCurrentChange(val) {
      this.config.pageNum = val
      this.$nextTick(() => {
        this.fetch()
      })
    }
  }
}
</script>
